import ContainedButton from "components/layout/form/containedButton";
import styled, { css } from "styled-components";
import { Form } from "formik";
import { Modal } from "react-bootstrap";

type ModalStyleProps = {
  modalImage?: boolean;
};

export const ModalStyle = styled(Modal)<ModalStyleProps>`
  .modal-content {
    max-width: 648px;
    width: 100%;
    border-radius: 10px;

    ${({ modalImage }) =>
      modalImage &&
      css`
        max-width: 420px;
      `}
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;

    ${({ modalImage }) =>
      modalImage &&
      css`
        max-width: 420px;
      `}
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  flex: 1;

  h1 {
    color: ${({ theme }) => theme.colors.blue};
    font-size: 1.4375rem;
    font-weight: bold;
    text-align: left;
    line-height: 18px;
    margin-bottom: 12px;
  }

  h2 {
    color: #5e5e5e;
    font-size: 0.9375rem;
    text-align: left;
    line-height: 26px;
    margin-bottom: 22px;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 768px) {
    margin-top: 0;
    justify-content: center;
    min-height: calc(100vh - 356px);
  }
`;

export const PrimaryColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;
  max-width: 426px;

  @media (max-width: 768px) {
    max-width: 320px;
  }
`;

export const SecondColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 43px;

  @media (max-width: 1125px) {
    display: none;
  }
`;

export const Label = styled.span`
  color: #5e5e5e;
  margin-bottom: 22px;
  svg {
    margin-left: -5px;
    margin-right: 4px;
  }
`;

export const FormContainer = styled(Form)`
  max-width: 420px;
`;

export const InputsContainer = styled.div`
  width: 100%;
  margin-bottom: 30px;
  margin-top: 30px;
  display: flex;
  gap: 50px;

  p {
    color: #000000;
    font-size: 0.75rem;
    line-height: 14px;
  }
`;

export const ButtonsContainer = styled.div`
  width: 100%;
  flex-direction: column;
  button {
    margin-bottom: 20px;
  }
`;

export const SelectorField = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  input {
    margin-right: 11px;
  }

  label {
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 16px;
    color: #4d565c;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  place-content: center;
  place-items: center;
  flex-direction: column;
  height: 247px;
  width: 238px;
  position: relative;

  img {
    height: 100%;
    width: 100%;
  }

  span {
    color: black;
    font-size: 0.75rem;
    margin: 0;
    margin-top: 10px;
  }

  @media (max-width: 1125px) {
    margin-left: 0;
  }
`;

export const IconContact = styled.div`
  height: 53px;
  width: 53px;
  background-color: #0b29fb;
  color: #97f8fb;
  border-radius: 50%;
  padding: 12px;
  display: flex;
  place-items: center;
  place-content: center;
  place-self: center;
`;

export const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 12px;
  line-height: 18.5px;
  color: #0b29fb;

  p:first-child {
    margin-bottom: 8px;
    font-weight: 600;
  }
`;

export const ContactCard = styled.div`
  display: grid;
  grid-template-columns: 53px auto;
  column-gap: 18px;
`;

export const InforCardContact = styled.section`
  background-color: white;
  border: 1px solid #0b29fb;
  border-radius: 10px;
  padding: 12px 15px;
  margin: 20px 0;

  h1 {
    color: black;
    margin: 0;
    margin-bottom: 20px;
  }
`;

export const Tooltip = styled.label`
  position: relative;
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.blue};
  display: flex;
  align-items: center;
  font-weight: 400;
  justify-content: flex-end;
  cursor: pointer;

  button {
    margin-left: 12px;
    color: white;
    background-color: #f0b01b;
    border: none;
    border-radius: 100%;
    height: 15px;
    width: 15px;
    font-size: 11px;
    font-weight: bold;
    display: flex;
    place-content: center;
  }

  #question {
    background-color: white;
    color: #363636;
    border-radius: 5px;
    font-size: 12px;
    opacity: 1;
    max-width: 382px;
    border: 1px solid #cfcfcf;
  }

  .__react_component_tooltip.type-dark.place-top:after {
    border-top-color: #cfcfcf !important;
  }
`;

export const Header = styled.header`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Error = styled.span`
  color: #dc3545;
`;

export const MeterContainer = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    place-content: center;
    flex-direction: column;
    width: auto;
    max-width: 238px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
  }

  @media (max-width: 1125px) {
    display: flex;
    place-content: center;
    flex-direction: column;
    width: auto;
    max-width: 238px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 10px;
  }
`;

export const Plus = styled.div`
  width: 26px;
  height: 26px;
  position: absolute;
  color: #288efd;
  top: -13px;
  right: -13px;
  display: flex;
  place-content: center;
  place-items: center;
  place-self: center;
  background-color: #f5f5f5;

  @media (max-width: 768px) {
    background-color: white;
  }
`;

export const ChatButton = styled.button`
  border: 0;
  background-color: inherit;
  cursor: pointer;
  text-decoration: underline;
  color: blue;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 26px 18px;
  padding-bottom: 0;
  font-family: "Mangueira Bold", sans-serif;
  color: #ffc107;
  font-size: 18px;
`;

export const ModalTitle = styled.span``;

export const ModalMedidorTitle = styled.span`
  color: #0000ff;
`;

export const ModalIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
`;

export const ModalText = styled.div`
  font-family: "Mangueira", sans-serif;
  font-size: 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 16px;

  span {
    display: inline-block;
    text-align: center;
  }
`;

export const ModalButton = styled(ContainedButton)`
  width: 100%;
  background-color: #ffc107;
  margin-top: 18px;
`;

export const LinkOpenModal = styled.span`
  color: #0000ff;
  font-family: "Mangueira", sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;

export const ModalImageWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;

export const ModalImage = styled.img``;

export const SubTitle = styled.span`
  width: 538px !important;

  @media (max-width: 768px) {
    max-width: 320px;
  }
`;
